import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { LanguageService } from "../../services/language.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-call-to-action',
  templateUrl: './call-to-action.component.html',
  styleUrl: './call-to-action.component.scss'
})
export class CallToActionComponent implements OnInit, OnDestroy {
  @Input() giPantMode: boolean = false;
  @Input() henterPantMode: boolean = false;

  private _translateService: TranslateService = inject(TranslateService);
  private _router: Router = inject(Router);
  private _languageService : LanguageService = inject(LanguageService);

  langSubscription!: Subscription;
  currentLang!: string;

  constructor() {
  }

  ngOnInit(): void {
    this.currentLang = this._languageService.currentLang;
    this.languageSubscription();
  }

  languageSubscription(): void {
    this.langSubscription = this._languageService.onLangChange$.subscribe((event: any) => {
      this.currentLang = this._languageService.currentLang;
    });
  }

  goToPickUpForm(): void {
    const el: Element | null = document.querySelector('#pick-up-request');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  goToSignUp(): void {
    const currentLang: string = this._translateService.currentLang;
    const queryParams = {tab: 'sign-up'};
    this._router.navigate([`/${currentLang}/henter-pant/profile`], {queryParams});
  }

  ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
  }
}
